// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import Seo from "../../components/Seo";

export default function ThanksPage() {
  return (
    <main>
      <Seo title="送信完了" path="/contact/thanks" noindex />
      <section className="section form-page thanks">
        <div className="container">
          <p className="f-label">THANK YOU</p>
          <h1 className="f-title">お問い合わせありがとうございます</h1>
          <p className="f-lead">
            送信が完了しました。ご入力いただいたメールアドレスに、受付完了のメールをお送りしています。
            <br />
            内容を確認のうえ、2〜3営業日以内に担当者よりご連絡いたします。
          </p>
          <div className="thanks-links">
            <Link className="btn btn-sub" to="/">
              トップへ戻る
            </Link>
            <Link className="btn btn-sub" to="/cases">
              実績を見る
            </Link>
            <a className="btn btn-sub" href="https://leaps-inc.com/media/">
              LEAPS AI Media を読む
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
